<template>
<div>
    <div role="alert" class="mcc-alert mcc-alert--primary-solid error-msg-div" style="margin-bottom:0px;">
        <div class="mcc-row">
            <div class="mcc-col mcc-col-8 error-msg">
                <p class="error-heading">Oh no, an error page!</p>
                <p class="error-body">Sorry, we couldn’t find the page you were looking for. Try again, or contact our support team. </p>
                <button class="mcc-button mcc-button--outline" @click="RedirectToHome()" title="Back">
                    <mcc-icon name="home" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Home</span>
                </button>
            </div>
            <div class="mcc-col mcc-col-4 error-icon">
                <div class="mcc-filtered-icon__name">
                    <mcc-icon name="nothing_found" aria-hidden="true" icon-set="fluency-color"></mcc-icon>
                </div>
            </div>
        </div>
    </div>
</div>
</template>


<script>
export default {
    name: "NotFoundError",
    data() {
        return {
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH
        }
    },
    methods: {
        RedirectToHome: function () {
            window.location = this.CONTEXT_PATH + "/category/view/Home";
        }
    }
}
</script>

<style scoped>
.error-msg-div {
    max-width: 550px;
    margin: auto;
    padding: 25px;
    --mds-alert-accent-border-color: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.error-heading {
    font-size: 18px;
    font-weight: bolder;
    color: var(--mds-button-outline-color, var(--mds-text-color-default, #161616));
}

.error-icon {
    background-color: var(--mds-ui-color-02, #eeeef1);
    border-radius: 15px;
}

.mcc-filtered-icon__name {
    transform: translate(15%, 50%);
}

.mcc-icon {
    --mds-alert-base-icon-fill: var(--mds-button-outline-color, var(--mds-text-color-default, #161616))
}

.mcc-filtered-icon__name svg {
    width: 100px !important;
    height: 100px !important;
}
</style>
